import React, { useState } from "react";
import JoinUsImg from "../image/joinUs.jpg"; // Make sure the path is correct
import "./JoinUs.css";

const JoinUs = () => {
  const [email, setEmail] = useState("");

  const handleSignUp = () => {
    alert(`Signed up with: ${email}`);
  };

  return (
    <div className="join-us-container">
      <div className="overlay"></div>{" "}
      {/* Dark overlay for better readability */}
      <div className="join-content">
        <h1>Join with us</h1>
        <p>
          Join our email list and get access to specials deals exclusive to our
          subscribers
        </p>
        <div className="signup-form">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button onClick={handleSignUp}>Sign Up</button>
        </div>
      </div>
    </div>
  );
};

export default JoinUs;
